module.exports = __webpack_public_path__ + "media/7.35023019.mp3";